<template>
  <div v-if="error || deleteError" class="fill-height">
    <GenericError />
  </div>

  <div v-else-if="isLoading" class="content-spinner">
    <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
  </div>

  <div v-else-if="item" class="v-container pa-5">
    <v-row class="layout-gap">
      <v-col cols="12" sm="6" md="5" lg="4">
        <img src="https://www.svgrepo.com/show/26995/avatar.svg" alt="" />
      </v-col>
      <v-col cols="12" sm="6" md="7" lg="8">
        <h1>{{ item.user.firstName }} {{ item.user.lastName }}</h1>
        <p class="subheading grey--text text--darken-1">
          {{ item.vesselRole['name'] }}
        </p>

        <table class="table-alt">
          <tbody>
            <tr>
              <td class="text-uppercase"><strong>Username</strong></td>
              <td>{{ item.user['username'] }}</td>
            </tr>
            <tr>
              <td class="text-uppercase"><strong>Email</strong></td>
              <td>{{ item.user['email'] }}</td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>

    <!--
    <router-link
      v-if="item"
      :to="{ name: 'RoleInVesselList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="deleteItem(item)">Delete
      </button>
      -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    deleteError: 'roleinvessel/del/error',
    error: 'roleinvessel/show/error',
    isLoading: 'roleinvessel/show/isLoading',
    item: 'roleinvessel/show/retrieved'
  }),

  beforeDestroy() {
    this.reset()
  },

  created() {
    this.retrieve('/role_in_vessels/' + this.$route.params.id)
  },

  methods: {
    ...mapActions({
      del: 'roleinvessel/del/del',
      reset: 'roleinvessel/show/reset',
      retrieve: 'roleinvessel/show/retrieve'
    }),

    deleteItem(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'RoleInVesselList' }))
      }
    }
  }
}
</script>
